import React from "react";
import moment from "moment";
import { useLocation } from "react-router-dom";

export function Footer() {
  const location = useLocation();
  const isAdminLogin = location.pathname === "/admin/login";

  return (
    <div className="footer">
      <div className="left">
        © {moment().year()} Copyright Sun Life Malaysia Blood Glucose
        Screening Programme. All Rights Reserved
        {!isAdminLogin && (
          <>
            <br />
            <br />
            <div>
              Sun Life Malaysia Assurance Berhad (199001005930 (197499-U))
              <br />
              Sun Life Malaysia Takaful Berhad (200501012215 (689263-M))
            </div>
          </>
        )}
      </div>
      <div className="right">
        {/* You can uncomment and use the links below if needed */}
        {/*
        <div><a href={`${process.env.REACT_APP_MAIN_SITE_URL}/download-bookdoc-app/`}>Download BookDoc App</a></div>
        <div><a href={`${process.env.REACT_APP_MAIN_SITE_URL}/faqs`}>FAQs</a></div>
        <div><a href={`${process.env.REACT_APP_MAIN_SITE_URL}/contact-us`}>Contact Us</a></div>
        <div><a href={`${process.env.REACT_APP_MAIN_SITE_URL}/privacy-policy/`}>Privacy Policy</a></div>
        <div><a href={`${process.env.REACT_APP_MAIN_SITE_URL}/terms-of-use/`}>Terms of Use</a></div>
        */}
        Powered by BookDoc
      </div>
    </div>
  );
}
